// import { Base64 } from './index.js'
// import Vue from 'vue'
// async function request(method, params = {}) {
//   try {
//     let { RETURN_DATA } = await Vue.prototype.$runWorkH5.ssdpRequestApp({
//       ...JSON.parse(process.env[`VUE_APP_${method}`]),
//       data: {
//         BUS_DATA: Base64.encode(JSON.stringify(params))
//       }
//     })
//     RETURN_DATA = RETURN_DATA? JSON.parse(Base64.decode(RETURN_DATA)): RETURN_DATA
//     return RETURN_DATA
//   } catch (err) {
//     new Vue.prototype.$Dialog({
//       title: "温馨提示",
//       text: typeof err === "string" ? err :  err.RETURN_DESC,
//       theme: "ios",
//       isConfirm: false
//     });
//     return Promise.reject(err)
//   }
// }

// export default request
import Vue from 'vue'
import { Base64 } from './index.js'
import { jssdk } from '@runwork/runwork-help'
function requestBy2({ api, version, data } = {}) {
  return new Promise((resolve, reject) => {
    crh.ssdpCallPost({
      param: {
        apiId: api,
        apiVersion: version,
        apiAuthType: process.env.NODE_ENV === 'development' ? '0' : '2',
        signType: '1',
        shouldEncryptParam: false,
        biz: data
      },
      success: res => {
        console.warn('2.0请求成功', res)
        if (typeof res === 'string') {
          res = JSON.parse(res)
        }
        let { RETURN_CODE, RETURN_DESC, RETURN_DATA } = res.RESPONSE
        if (!['S000A000', 'S0A00000', 'S1A00000'].includes(RETURN_CODE)) {
          console.warn(RETURN_CODE)
          new Vue.prototype.$Dialog({
            title: '温馨提示',
            text: RETURN_CODE,
            theme: 'ios',
            isConfirm: false
          })
          reject(RETURN_DESC)
        } else {
          resolve(
            RETURN_DATA ? JSON.parse(Base64.decode(RETURN_DATA)) : RETURN_DATA
          )
        }
      },
      fail: err => {
        console.log(Base64.decode(err.returnData));
        console.log(`2.0接口调用失败：${api}`, err);
        crh.getNetworkType({
          success: res => {
            if (res.networkType == "none") {
              new Vue.prototype.$Dialog({
                title: "温馨提示",
                text: "网络异常",
                onOk() {
                  crh.closeWebApp();
                  return;
                },
                theme: "ios",
                confirm: false,
              });
            } else {
              let { returnDesc, returnData } = err;
              console.log("2", returnData);
              returnData = JSON.parse(Base64.decode(returnData));
              console.log("3", returnData);
              let { RETURN_DATA, RETURN_CODE, RETURN_DESC } = returnData.RESPONSE;
              new Vue.prototype.$Dialog({
                title: "温馨提示",
                text: RETURN_DESC,
                onOk() {
                  crh.closeWebApp();
                  return;
                },
              });
            }
          },
        });
        reject(err);
      }
    })
  })
}
async function request3Dtg({ api, version, data } = {}, callback) {
  try {
    let response = await Vue.prototype.$runWorkH5.ssdpRequestApp({
      api,
      version,
      data
    })
    callback(response)
    return response
  } catch (err) {
    new Vue.prototype.$Dialog({
      title: '温馨提示',
      text: typeof err === 'string' ? err : err.RETURN_DESC,
      theme: 'ios',
      onOk() {
        window.tt.closeWindow({})
        return;
      },
    })
    Promise.reject(err)
  }
}
async function requestBy3({ api, version, data } = {}) {
  return new Promise((resolve, reject) => {
    request3Dtg({ api, version, data }, (response) => {
      let { RETURN_CODE, RETURN_DESC, RETURN_DATA } = response
      if (!['S000A000', 'S0A00000', 'S1A00000'].includes(RETURN_CODE)) {
        new Vue.prototype.$Dialog({
          title: '温馨提示',
          text: typeof RETURN_DESC === 'string' ? RETURN_DESC : RETURN_DESC.RETURN_DESC,
          theme: 'ios',
          onOk() {
            window.close()
            return;
          },
        })
        reject(RETURN_DESC)
      } else {
        RETURN_DATA = RETURN_DATA
          ? JSON.parse(Base64.decode(RETURN_DATA))
          : RETURN_DATA
        resolve(RETURN_DATA)
      }
    })

  })
}
async function request1Dtg({ api, version, data } = {}, callback) {
  try {
    let { data: response } = await Vue.prototype.ssdpRequestDtgw.request({
      api,
      version,
      data
    })
    callback(response)
    return response
  } catch (err) {
    new Vue.prototype.$Dialog({
      title: '温馨提示',
      text: typeof err === 'string' ? err : err.RETURN_DESC,
      theme: 'ios',
      onOk() {
        let ua = navigator.userAgent.toLowerCase()
        let uaAndroid = /android/i.test(ua) // test返回的是true/false
        let uaIos = /iphone|ipad|ipod/i.test(ua)
        if (window.WeixinJSBridge) {
          window.WeixinJSBridge.call('closeWindow') // 微信
        } else if (window.AlipayJSBridge) {
          window.AlipayJSBridge.call('closeWebview') // 支付宝
        } else if (isLppzApp && uaAndroid) {
          window.obj.closePageLppzRequest('') // 安卓app
        } else if (isLppzApp && uaIos) {
          window.webkit.messageHandlers.closePageLppzRequest.postMessage('') //ios app
        } else {
          window.close()
        }
        return;
      },
    })
    Promise.reject(err)
  }
}
async function requestBy1({ api, version, data } = {}) {
  return new Promise((resolve, reject) => {
    request1Dtg({ api, version, data }, (response) => {
      let { RETURN_CODE, RETURN_DESC, RETURN_DATA } = response.RESPONSE;
      if (!['S000A000', 'S0A00000', 'S1A00000'].includes(RETURN_CODE)) {
        new Vue.prototype.$Dialog({
          title: '温馨提示',
          text: typeof RETURN_DESC === 'string' ? RETURN_DESC : RETURN_DESC.RETURN_DESC,
          theme: 'ios',
          onOk() {
            let ua = navigator.userAgent.toLowerCase()
            let uaAndroid = /android/i.test(ua) // test返回的是true/false
            let uaIos = /iphone|ipad|ipod/i.test(ua)
            if (window.WeixinJSBridge) {
              window.WeixinJSBridge.call('closeWindow') // 微信
            } else if (window.AlipayJSBridge) {
              window.AlipayJSBridge.call('closeWebview') // 支付宝
            } else if (isLppzApp && uaAndroid) {
              window.obj.closePageLppzRequest('') // 安卓app
            } else if (isLppzApp && uaIos) {
              window.webkit.messageHandlers.closePageLppzRequest.postMessage('') //ios app
            } else {
              window.close()
            }
            return;
          },
        })
        reject(RETURN_DESC)
      } else {
        RETURN_DATA = RETURN_DATA
          ? JSON.parse(Base64.decode(RETURN_DATA))
          : RETURN_DATA
        resolve(RETURN_DATA)
      }
    })

  })
}
export default function request(method, params = {}) {
  let ssdp = { ...JSON.parse(process.env[`VUE_APP_${method}`]) }
  let option = {
    ...ssdp,
    data: {
      BUS_DATA: Base64.encode(JSON.stringify(params))
    }
  }
  let platform = 1
  if (!!window.h5sdk || process.env.NODE_ENV === "development") {
    platform = 3
  } else {
    if (Vue.prototype.isRunwork) {
      platform = 2
    } else {
      platform = 1
    }
  }
  let request = requestBy1
  console.log(platform,'platform--')
  switch (platform) {
    case 1:
      request = requestBy1
      break
    case 2:
      request = requestBy2
      break
    case 3:
      request = requestBy3
      break
  }
  console.log(platform, '------3333----')
  // return Vue.prototype.platform === 2 ? requestBy2(option) : requestBy3(option)
  return request(option)
}
